import { render, staticRenderFns } from "./SiteFooterContent.vue?vue&type=template&id=606786e8&"
import script from "./SiteFooterContent.vue?vue&type=script&lang=js&"
export * from "./SiteFooterContent.vue?vue&type=script&lang=js&"
import style0 from "./SiteFooterContent.vue?vue&type=style&index=0&id=606786e8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports